.pageTitle {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}
